

// const APIKey= c24f0decb97e40c8b104771db4475464;


const data={
    Products: [
      {
          id:'1',
          name:'strawberry',
          price:50,
           image:'https://picsum.photos/id/1080/6858/4574',
      },
      {
          id:'2',
          name:'Onion',
          price:20,
         image:'https://picsum.photos/id/292/3852/2556',
      },
      {
          id:'3',
          name:'Honey',
          price:30,
          image:'https://picsum.photos/id/312/367/267'
      },
      {
          id:'4',
          name:'Raspberry',
          price:40,
          image:'https://picsum.photos/id/429/367/267'
      },
      {
          id:'5',
          name:'Grape',
          price:45,
          image:'https://picsum.photos/id/674/367/267'
      },
      {
          id:'6',
          name:'Blueberies',
          price:55,
          image:'https://picsum.photos/id/75/367/267'
      },
      {
          id:'7',
          name:'Coffee',
          price:55,
          image:'https://picsum.photos/id/766/367/267'
      },
      {
          id:'8',
          name:'Cookies',
          price:25,
          image:'https://picsum.photos/id/835/367/267'
      },
  ],
} ;                                                    
export default data;